import { formatNumeral } from '@/utils/function'
import { useTranslation } from 'react-i18next'
import StatisticCard from './StatisticCard'

interface StatisticsCardsProps {
    statistics: {
        totalRevenue: number
        actualRevenue: number
        projectedRevenue: number
        paidAmount: number
        unpaidAmount: number
    }
    summary?: {
        total_records?: number
        total_actual_records?: number
        total_projected_records?: number
        total_paid_records?: number
        total_unpaid_records?: number
        total_by_invoice_id?: number
        total_by_customer_id?: number
        total_by_service_id?: number
    }
}

const StatisticsCards: React.FC<StatisticsCardsProps> = ({
    statistics,
    summary,
}) => {
    const { t } = useTranslation()

    return (
        <div className="bg-white border rounded-lg px-2 py-1.5">
            <div className="grid grid-cols-8 gap-1 items-center">
                {/* Revenue Stats - 5 columns */}
                <StatisticCard
                    title={t('total_revenue')}
                    subtitle={t('total_revenue_subtitle')}
                    value={statistics.totalRevenue}
                    recordsCount={summary?.total_records}
                    colorVariant="blue"
                    isPrice
                    compact
                />

                <StatisticCard
                    title={t('actual_revenue')}
                    subtitle={t('actual_revenue_subtitle')}
                    value={statistics.actualRevenue}
                    recordsCount={summary?.total_actual_records}
                    colorVariant="green"
                    isPrice
                    compact
                />

                <StatisticCard
                    title={t('projected_revenue')}
                    subtitle={t('projected_revenue_subtitle')}
                    value={statistics.projectedRevenue}
                    recordsCount={summary?.total_projected_records}
                    colorVariant="amber"
                    isPrice
                    compact
                />

                <StatisticCard
                    title={t('paid_amount')}
                    subtitle={t('paid_amount_subtitle')}
                    value={statistics.paidAmount}
                    recordsCount={summary?.total_paid_records}
                    colorVariant="teal"
                    isPrice
                    compact
                />

                <StatisticCard
                    title={t('unpaid_amount')}
                    subtitle={t('unpaid_amount_subtitle')}
                    value={statistics.unpaidAmount}
                    recordsCount={summary?.total_unpaid_records}
                    colorVariant="red"
                    isPrice
                    compact
                />

                {/* Count Stats - 3 columns */}
                <StatisticCard
                    title={t('total_invoices')}
                    value={formatNumeral(summary?.total_by_invoice_id || 0, 0)}
                    colorVariant="purple"
                    compact
                />

                <StatisticCard
                    title={t('total_customers')}
                    value={formatNumeral(summary?.total_by_customer_id || 0, 0)}
                    colorVariant="indigo"
                    compact
                />

                <StatisticCard
                    title={t('total_services')}
                    value={formatNumeral(summary?.total_by_service_id || 0, 0)}
                    colorVariant="cyan"
                    compact
                />
            </div>
        </div>
    )
}

export default StatisticsCards
